import { render, staticRenderFns } from "./BasketPage.vue?vue&type=template&id=7e5ce5d2&"
import script from "./BasketPage.vue?vue&type=script&lang=js&"
export * from "./BasketPage.vue?vue&type=script&lang=js&"
import style0 from "./BasketPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports